import { X, Plus, Trash2 } from "lucide-react";
import SmallInputField from "./SmallInputField";

const PaymentScheduleInput = ({ value = [], onChange }) => {
  const handleChange = (index, field, fieldValue) => {
    const updated = value.map((item, i) =>
      i === index ? { ...item, [field]: fieldValue } : item
    );
    onChange?.(updated);
  };

  const handleAdd = () => {
    const nextStep = value.length + 1;
    onChange?.([
      ...value,
      { step: nextStep, stage: "", percentage: "", description: "" },
    ]);
  };

  const handleRemove = (index) => {
    const updated = value
      .filter((_, i) => i !== index)
      .map((v, i) => ({ ...v, step: i + 1 }));

    // Send empty array when all removed
    onChange?.(updated);
  };

  return (
    <div className="space-y-4">
      {value?.map((item, index) => (
        <div
          key={index}
          className="relative border  border-border rounded-lg bg-background-card p-4 ring-1 ring-transparent focus-within:ring-primary/40 transition-all duration-200"
        >
          {/* <button
            type="button"
            onClick={() => handleRemove(index)}
            className="absolute -right-2 -top-2 text-text-muted hover:text-btn-warning transition"
          >
            <X size={18} />
          </button> */}
          <button
            type="button"
            onClick={() => handleRemove(index)}
            className="absolute -right-1 -top-1 p-1.5 rounded-md text-gray-400 hover:text-red-600 hover:bg-red-50 transition-all duration-200 group"
            title="Remove payment step"
          >
            <Trash2
              size={16}
              className="group-hover:scale-110 transition-transform"
            />
          </button>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <SmallInputField
              type="number"
              label="Step No."
              value={item.step}
              onChange={() => {}}
            />
            <SmallInputField
              type="number"
              label="Percentage (%)"
              value={item.percentage}
              onChange={(e) =>
                handleChange(index, "percentage", Number(e.target.value))
              }
              placeholder="e.g. 10"
            />
          </div>

          <div className="grid grid-cols-1 gap-3">
            <SmallInputField
              label="Phase"
              value={item.stage}
              onChange={(e) => handleChange(index, "stage", e.target.value)}
              placeholder="e.g. Foundation Completion"
            />

            <SmallInputField
              label="Description (Optional)"
              value={item.description}
              onChange={(e) =>
                handleChange(index, "description", e.target.value)
              }
              placeholder="Additional notes if needed"
            />
          </div>
        </div>
      ))}

      <button
        type="button"
        onClick={handleAdd}
        className="flex items-center gap-2 mt-4 text-sm text-btn-primary font-medium hover:opacity-80 transition"
      >
        <Plus size={18} /> Add Payment Step
      </button>
    </div>
  );
};

export default PaymentScheduleInput;
